/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import 'babel-polyfill'
import 'custom-event-polyfill'
import * as i18next from 'i18next'
import { List, Map } from 'immutable'
import 'lazysizes'
import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation.min'
import * as ReactDOM from 'react-dom'
import 'url-search-params-polyfill'
import 'whatwg-fetch'
import {
  Action,
  AsyncState,
  Fun,
  mk_pair,
  none,
  Option,
  Pair,
  unloadedAsyncState,
  Widget
} from 'widgets-for-react'
import { TemplateState } from './components/cms/page/types.gen'
import { AppState, PageTemplateState } from './components/cms/state/types.gen'
import { CustomBlock } from './components/drupal/types_and_parser/custom_blocks.mod'
import { Breadcrumb, ParsedMenuItem, CustomParsedNode } from './components/drupal/types_and_parser/extra_types.mod'
import { Block } from './components/drupal/types_and_parser/standard_blocks.gen'
import { ParsedNode } from './components/drupal/types_and_parser/types'
import { Locale } from './components/drupal/types_and_parser/extra_types.mod'
import { BatchRequestResponse } from './components/http_batch'
import {
  application,
  getDrupalLanguage,
  getPage,
  InitPagesStates,
  PublicSite_CustomPageData
} from './components/public_site/application.mod'
import { CustomBlockData } from './components/public_site/blocks/custom_blocks/types.mod'
import { blocks_renderer } from './components/public_site/blocks/renderer.mod'
import {
  //custom_page1,
  //custom_page2,
  styleguide,
  press,
  empty_overview,
  overviewPage
} from './components/public_site/custom_pages/custom_pages.mod'
import { selectLocale } from './components/public_site/custom_pages/select_locale'
import { requestDocuments, emptyBimAndDrawingsForm } from './components/public_site/custom_pages/request_documents'
import { story_overview } from './components/public_site/custom_pages/story_overview'
import { search_overview } from './components/public_site/custom_pages/search_overview'
// import { products_overview } from './components/public_site/custom_pages/products_overview'
import { CustomPagesState, PublicSiteCustomRoutes } from './components/public_site/custom_pages/types.mod'
// import { vacancies_overview } from './components/public_site/custom_pages/vacancies_overview'
import { page } from './components/public_site/templates/drupal_page.mod'
import { notfound_page } from './components/public_site/templates/error_page.mod'
import { footer } from './components/public_site/templates/footer.mod'
import { header, productdetailpageHeader, selectRegionNoRedirect } from './components/public_site/templates/header.mod'
import { loader } from './components/public_site/templates/loader.mod'
import { ExtraImages } from './components/public_site/utils/extra_images.mod'
import { getLangFromUrl } from './components/public_site/utils/history.mod'
import { getCookie } from './components/cms/blocks/cookiebar.utils.mod'
import { getFormState } from './components/form/api'
import { vacancy_detail } from './components/public_site/custom_pages/pages/vacancyDetailPage/vacancy_detail'
import { getVacancyIdFromUrl } from './components/public_site/utils/helpers'
import { vacancy_detail_success } from './components/public_site/custom_pages/pages/vacancyDetailPage/vacancy_detail_success'
import { stateful } from './stateful.polyfill'

export type ViewPortSize = 'mobile' | 'tablet' | 'desktop'

export type HeaderState = {
  mode: 'closed' | 'open'
  countriesNav: 'closed' | 'open'
  searchNav: 'closed' | 'open'
  selectRegionNav: 'closed' | 'open'
  menuHeader: HeaderMenus
  topMenu: AsyncState<List<ParsedMenuItem>>
  countryMenu: AsyncState<List<ParsedMenuItem>>
  currentLanguage: Locale
  node: ParsedNode | CustomParsedNode | 'none'
  hoveredPrimMenuItem?: ParsedMenuItem
  hoveredSecMenuItem?: ParsedMenuItem
  searchQuery: string
  isTransparent: boolean
}

export type FooterState = {
  menu: AsyncState<List<ParsedMenuItem>>
  privacyMenu: AsyncState<List<ParsedMenuItem>>
  node: ParsedNode | CustomParsedNode | 'none'
}

export type HeaderMenus = {
  navLinks: AsyncState<List<ParsedMenuItem>>
  languages: AsyncState<List<string>>
}

export type PublicSiteState = {
  header: HeaderState
  footer: FooterState
  batch_get_header_footer: AsyncState<BatchRequestResponse[]> //body + get_language
  //viewport: ViewPortSize
  year: number
} & PageTemplateState<
  CustomBlockData,
  CustomBlock,
  Block,
  ExtraImages,
  PublicSite_CustomPageData,
  any // change this to PublicSiteState when circular reference is supported in TS
> &
  CustomPagesState

export const defaultPage: ContentType = (x) => x

export type ContentType = (
  placeholder: Widget<
    Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
  >
) => Widget<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>

const initPagesStates = InitPagesStates(blocks_renderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>())

const vacancyIdOption = getVacancyIdFromUrl()
export const emptyAppState = (page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType>): PublicSiteState => ({
  ...initPagesStates,
  batch_get_header_footer: unloadedAsyncState(),
  page: {
    ...initPagesStates.page,
    get_page: getPage,
    display: page(mk_pair(List(), none()))
  },
  vacancyItem: {
    get_vacancy: unloadedAsyncState(),
    form: getFormState([], "vacancyapplication2", vacancyIdOption.v.kind == 'r' ? vacancyIdOption.v.v : ''),
    current_view: "vacancy-detail"
  },
  success: {
    get_vacancy: unloadedAsyncState(),
    form: getFormState([], "vacancyapplication2", vacancyIdOption.v.kind == 'r' ? vacancyIdOption.v.v : ''),
  },
  overview: empty_overview()(undefined, true),
  header: {
    isTransparent: true,
    mode: 'closed',
    countriesNav: 'closed',
    searchNav: 'closed',
    selectRegionNav: 'closed',
    menuHeader: {
      navLinks: unloadedAsyncState(),
      languages: unloadedAsyncState() //loadingAsyncState(() => Api.loadLanguages()),
    },
    currentLanguage: getDrupalLanguage(getLangFromUrl()),
    node: 'none',
    topMenu: unloadedAsyncState(), //loadingAsyncState(() => Api.loadTopMenu())
    countryMenu: unloadedAsyncState(), //loadingAsyncState(() => Api.loadTopMenu())
    searchQuery: ''
  },
  footer: {
    menu: unloadedAsyncState(), //loadingAsyncState(() => Api.loadFooter()),
    privacyMenu: unloadedAsyncState(), //loadingAsyncState(() => Api.loadPrivacyMenu())
    node: 'none'
  },
  styleguide: {},
  press: {
    page: null,
    pressRelease: unloadedAsyncState()
  },
  year: 2020,
  // custom_page1: {},
  // custom_page2: {
  //   get_random_number: unloadedAsyncState(),
  //   page: 0
  //},
  selectLocale: {},
  requestDocuments: {
    bimAndDrawingsFormState: emptyBimAndDrawingsForm()
  },
  story_overview: {
    overview_page: 0,
    storyPage: unloadedAsyncState(),
    get_stories: unloadedAsyncState()
  },
  search_overview: {
    overview_page: 0,
    current_query: '',
    get_searches: unloadedAsyncState(),
  }
  // cases_overview: {
  //   overview_page: 0,
  //   get_cases: unloadedAsyncState()
  // },
  // products_overview: {
  //   get_products: unloadedAsyncState()
  // },
  // vacancies_overview: {
  //   get_vacancies: unloadedAsyncState()
  // }
})

// 'hk',
// 'ie',
// 'in',
// 'no',
// 'se',
// 'ru',
// 'ae',
// 'mx',
// 'my',
// 'au',
// 'cn',
// 'dk',
// 'be_nl',
// 'be_fr',

export const allLanguages: Array<Locale> = [
  'de',
  'es',
  'fr',
  'it',
  'fi',
  'nl',
  'na',
  'uk',
  'us',
  'global',
  'be_nl',
  'be_fr',
  'na-fr',
  'na-es',
  'pl',
  'au'
]

// mx: 'Latin America',
// my: 'Malaysia',  
// ae: 'United Arab Emirates',
// au: 'Australia',
// hk: 'Hong Kong',
// ie: 'Ireland',
// in: 'India',  
// dk: 'Danmark',
// cn: '中国',
// no: 'Norge',
// ru: 'Россия',
// se: 'Sverige',


export const localeTranslations = Map<Locale, string>({
  global: 'Global — English',
  de: 'Deutschland',
  es: 'España',
  fr: 'France',
  it: 'Italia',
  fi: 'Finland',
  be_nl: 'Nederlands — België',
  be_fr: 'Nederlands — Francais',
  'na-fr': 'North America — Francais',
  'na-es': 'North America — Spanish',
  nl: 'Nederland',
  uk: 'United Kingdom',
  us: 'United States',
  pl: 'Poland',
  au: 'Australia'
})

// export const recruitmentProcessCountryTranslations = Map<Locale, string>({
//   'Finland': 'fi',
//   'France': 'fr',
//   'Germany': 'de',
//   'Italy': 'it',
//   'Netherlands': 'nl',
//   'Belgium': 'nl',
//   'Spain': 'es',
//   'United Kingdom': 'uk',
//   'United States': 'en',
//   'Canada': 'en',
//   'Poland': 'pl'
// })

// no: 'no-NO',
// ru: 'ru-RP',
// se: 'sv-SE',
// ae: 'en-AE',
// au: 'en-AU',
// cn: 'zh-CN',
// hk: 'en-HK',
// ie: 'en-IE',
// in: 'en-IN',
// mx: 'es-419',
// my: 'en-MY',
// dk: 'da-DK',
// be_nl: 'nl-BE',
// be_fr: 'fr-BE',
export const localeISOcodes = Map<Locale, string>({
  global: 'x-default',
  de: 'de-DE',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  fi: 'fi-FI',
  nl: 'nl-NL',
  uk: 'en-GB',
  us: 'en-US',
  pl: 'PL',
  au: 'en-au'
})

export type CareersTranslation<T extends string> = { [p in T]: string }

export type CareersTranslatedSlug = {
  slug?: CareersTranslation<"en" | "na" | "uk" | "nl" | "fr" | "pl" | "de" | "es" | "fi" | "it" | 'na-fr' | 'au'>
  title?: CareersTranslation<"en" | "na" | "uk" | "nl" | "fr" | "pl" | "de" | "es" | "fi" | "it" | 'na-fr' | 'au'>
}

export const getTranslatedCareersSlugTitleData = (): CareersTranslatedSlug => {
  return {
    slug:
    {
      en: "careers",
      uk: "careers",
      na: "careers",
      nl: "werken-bij-refresco",
      fr: "nous-rejoindre",
      pl: "kariera",
      de: "karriere",
      es: "unete-al-equipo",
      fi: "tyoskentely-refrescossa",
      it: "lavorare-in-Refresco",
      'na-fr': "carrieres",
      au: 'careers'
    },
    title:
    {
      en: "Careers",
      uk: "Careers",
      na: "Careers",
      nl: "Kom bij ons werken",
      fr: "Nous rejoindre",
      pl: "Praca w Refresco",
      de: "Karriere",
      es: "Únete al equipo",
      fi: "Työskentely Refrescossa",
      it: "Lavorare in Refresco",
      'na-fr': "Carrières",
      au: 'Careers'
    }
  }
}

export const getTranslatedCareersSlugTitle = (): CareersTranslatedSlug => {
  let careersSlugTitle = getTranslatedCareersSlugTitleData()
  return careersSlugTitle
}

// ['cn', 'https://www.refresco.cn'],
// ['hk', 'https://www.refresco.hk'],
// ['in', 'https://www.refresco.in'],
// ['au', 'https://www.refresco.com.au'],
// ['mx', 'https://www.refresco.mx'],
// ['ae', 'https://www.refresco.ae'],
// ['my', 'https://www.refresco.my'],
// ['ru', 'https://www.refresco.ru'],

export const oldSites: Map<Locale, string> = Map<Locale, string>(window.allSites)

export const defaultLanguage: Locale = 'en'
export const getLanguage = (lang: string): Locale => allLanguages.find((l) => l === lang) || defaultLanguage

export const public_site_to = async (slug: string, target_element_id: string, project_name: string) => {
  const headers = new Headers()

  let res = await fetch(`/translations.json`, { method: 'get', credentials: 'include', headers: headers })
  let resources = await res.json()
  if (window.location.href.includes("clearcookie=true")) {
    selectRegionNoRedirect(oldSites.get("en"))
  }

  let cookieValue = getCookie("selectedRegion")
  if (cookieValue != undefined && cookieValue != "" && oldSites.get("en") != cookieValue && document.location.href == oldSites.get("en")) {
    console.log("redirecting", cookieValue)
    document.location.href = cookieValue
    return
  }

  i18next.init(
    {
      lng: getDrupalLanguage(getLangFromUrl()),
      fallbackLng: defaultLanguage,
      ns: ['translation',
        'Common',
        'GlobalProduct',
        'SubsidiaryProduct',
        'Property',
        'Cookies'
      ],
      resources: resources
    },
    (err, t) => {
      ReactDOM.render(
        stateful<AppState<PublicSiteState, PublicSiteCustomRoutes>>()(s0 => 
          application(
            { rootpath: '', rootpath_to_ignore: '/portal', login_address: '/portal' },
            header,
            productdetailpageHeader,
            footer,
            notfound_page,
            loader,
            page(none()),
            {
              //custom_page1,
              //custom_page2,
              selectLocale,
              requestDocuments,
              story_overview,
              search_overview,

              // products_overview,
              // vacancies_overview,
              styleguide,
              press,
              overview: overviewPage(),
              vacancyItem: vacancy_detail,
              success: vacancy_detail_success
            }
          )(s0)
        )({
          current_widget: none(),
          route: {
            kind: '404'
          },
          state: emptyAppState(page(none()))
        }).run((_) => null),
        document.getElementById(target_element_id)
      )
    }
  )
}

public_site_to("", "react-content", "Refresco")